"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _bootstrap = require("bootstrap");
var _reactBootstrap = require("react-bootstrap");
var _DeviceTable = require("../DeviceTable");
var _DevicesModule = _interopRequireDefault(require("../../styles/components/Devices.module.css"));
var _constants = require("../../utils/constants");
var _DeviceSwiper = require("./DeviceSwiper");
var _material = require("@mui/material");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Devices = props => {
  const {
    typeDisplay = _constants.contentType.layoutGrid
  } = props;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tabs, {
    transition: false,
    id: "controlled-tab-example",
    activeKey: typeDisplay,
    className: "mb-1 ".concat(_DevicesModule.default.tabs)
  }, /*#__PURE__*/_react.default.createElement(_bootstrap.Tab, {
    eventKey: _constants.contentType.layoutGrid
  }, /*#__PURE__*/_react.default.createElement(_DeviceSwiper.DeviceSwiper, null)), /*#__PURE__*/_react.default.createElement(_bootstrap.Tab, {
    eventKey: _constants.contentType.table
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1
  }, /*#__PURE__*/_react.default.createElement(_DeviceTable.DeviceTable, null))));
};
var _default = exports.default = Devices;